import styled, { css } from "styled-components";
import NumberFormat from "react-number-format";
import { Controller } from "react-hook-form";
import { Input } from "antd";

export const TPhoneInput = (props) => {
  return (
    <StyledContainer isError={props.errors && props.errors[props.name]}>
      {props.label && (
        <StyledLabel htmlFor={props.name}>{props.label}</StyledLabel>
      )}

      <Controller
        className={`styled-input ${
          props.errors && props.errors[props.name] && "input-error"
        }`}
        name={props.name}
        defaultValue={props.defaultValue}
        {...props.propsInput}
        render={({ value }) => {
          return (
            <NumberFormat
              format={
                props.numType === "mobile" ? "###-########" : "##-########"
              }
              defaultValue={value}
              customInput={Input}
              placeholder={props.placeholder}
              id={props.name}
              onValueChange={({ value }) => {
                props.setValue(props.name, value);
              }}
            />
          );
        }}
      />

      {props.errors && props.errors[props.name] && (
        <>
          <StyledError>
            <p>{props.errors && props.errors[props.name].message}</p>
          </StyledError>
        </>
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) => props.theme.spacing[3]};
  .styled-input {
    &.input-error,
    .input-error:focus {
      outline: none !important;
      border: ${(props) => `1px solid
          ${props.theme.colors.red[400]}`};
    }
  }
  ${(props) =>
    props.isError &&
    css`
      margin-bottom: 0;
    `};
`;

const StyledLabel = styled.label`
  font-weight: 500;
  color: ${(props) => props.theme.colors.grey[600]};
  margin-bottom: ${(props) => props.theme.spacing[1]};
`;

const StyledError = styled.span`
  color: ${(props) => props.theme.colors.red[600]};
  padding: 0;
  margin: 0;

  p {
    font-size: 0.8rem;
    margin: 0;
  }
`;
